import { Box } from '@wix/design-system';
import { PageDisclaimer, StudioCta } from '@wix/package-picker-shared-studio';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { ProductCards } from '../ProductCards';

export interface PlansSectionProps {
  gridRef: React.RefObject<HTMLDivElement>;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export const PlansSection = ({ gridRef, scrollRef }: PlansSectionProps) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  return (
    <Box direction="vertical" width="100%" align="center">
      <Box width="100%" marginTop="SP8">
        <ProductCards />
      </Box>
      <Box marginTop="SP4">
        <StudioCta
          size="medium"
          fullWidth={false}
          onClick={() => {
            gridRef.current?.scrollIntoView({ behavior: 'smooth' });
            StudioPackagePickerModule.internals.bi.onComparePlanFeaturesClick?.(
              {},
            );
          }}
        >
          {t('premium-purchase-plan.cards.compare_features.cta')}
        </StudioCta>
      </Box>
      <div ref={scrollRef} />
      <Box
        width="100%"
        marginTop="SP4"
        padding="20px 40px 0"
        boxSizing="border-box"
        textAlign="center"
        align="center"
      >
        <PageDisclaimer />
      </Box>
    </Box>
  );
};
